import { asOwaDateInUserTz } from 'owa-datetime';
import formatMonthDayYear from '../formatters/formatMonthDayYear';
import formatUserDate from '../formatters/formatUserDate';
import formatUserTime from '../formatters/formatUserTime';
import formatYear from '../formatters/formatYear';
import formatYearMonth from '../formatters/formatYearMonth';
import formatMonthName from '../formatters/formatMonthName';

// In certain cases @fluentui/react might call this with a null or undefined value.
// Ex: a date picker with text input and with no previous date selected.
const jsDateFormatter =
    (fn: typeof formatUserTime) =>
    (date: Date | null | undefined): string =>
        date ? fn(asOwaDateInUserTz(date)) : '';

export interface DateTimeFormatter {
    // When showing year/month and long dates we will respect the user's settings
    formatMonthDayYear: (date: Date | null | undefined) => string;
    formatMonth: (date: Date | null | undefined) => string;
    formatMonthYear: (date: Date | null | undefined) => string;
    formatYear: (date: Date | null | undefined) => string;
    // When showing just a day, we explicitly do not want padded values.
    formatDay: (date: Date) => string;
    formatUserDate: (date: Date | null | undefined) => string;
    formatUserTime: (date: Date | null | undefined) => string;
}

/**
 * Adapter to format dates provided by @fluentui/react's Calendar
 * using OWA's date and time formats.
 */
export const dateTimeFormatter: DateTimeFormatter = {
    // When showing year/month and long dates we will respect the user's settings
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function jsDateFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    formatMonthDayYear: jsDateFormatter(formatMonthDayYear),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function jsDateFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    formatMonth: jsDateFormatter(formatMonthName),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function jsDateFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    formatMonthYear: jsDateFormatter(formatYearMonth),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function jsDateFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    formatYear: jsDateFormatter(formatYear),

    // When showing just a day, we explicitly do not want padded values.
    formatDay: (date: Date): string => date.getDate().toString(),

    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function jsDateFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    formatUserDate: jsDateFormatter(formatUserDate),
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function jsDateFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    formatUserTime: jsDateFormatter(formatUserTime),
};
